import { mapState } from 'vuex';
export const policyMixin = {
  watch: {
    // 监听是否阅读告知书
    agreementRead(val) {
      if (val) {
        this.$nextTick(() => {
          // 阅读完告知书后，页面滚动到保单信息处
          const dom = document.querySelector('.policy-info');
          if (dom) {
            const top = dom.offsetTop;
            window.scrollTo({
              top: top,
              behavior: 'smooth'
            });
          }
        });
      }
    }
  },
  computed: {
		...mapState({
      agreementAllRead: (state) => state.insureDoc.agreementAllRead,//协议文件是否全部已读
      agreementRead: (state) => state.insureDoc.agreementRead,//是否阅读告知书
      fileCodeContent: (state) => state.occupationCode.fileCodeContent,//协议文件是否全部已读
      payTypeList: (state) => state.payMethod.payObj,//支付方式
      checkContent: (state) => state.riskNotify.checkContent,//检测是否需要上传风险告知函
    }),
    addressOptions() {
      //获取地址code
      return window.addrescode;
    },
  },
  methods: {
    countTimes() {},
    eduitSelect(data) {
      //修改被保人
      this.salInsuredList.forEach((e, i) => {
        //更新变更项
        if (i == data.eduitIndex) {
          this.salInsuredList[i] = data;
        }
        if (e.occulevel.toString().indexOf('类') <= -1) {
          e.occulevel = e.occulevel + '类';
        }
      });
      this.riskNumber = this.countTimes(this.salInsuredList);
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.salInsuredList);
      this.resultPremiumSum(this.RiskInfos); //计算保费
    },
    addSelectpre(data) {
      //粘贴被保人
      if (Array.isArray(data)) {
        var datas = data;
        this.salInsuredList.push(...datas);
      } else {
        this.salInsuredList.push(data);
      }
      let cesiData = this.$lodash.cloneDeep(this.salInsuredList);
      this.salInsuredList = this.unique(this.salInsuredList, 'idNumber');
      if (cesiData.length != this.salInsuredList.length) {
        this.$message.warning('受保人有重复，已做删除');
      }
      this.riskNumber = this.countTimes(this.salInsuredList);
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.salInsuredList);
      this.resultPremiumSum(this.RiskInfos); //计算保费
    },
    delSelectpre(data) {
      //批量删除被保人
      this.salInsuredList = data;
      let copyData = JSON.parse(JSON.stringify(this.salInsuredList));
      this.salInsuredList = this.unique(this.salInsuredList, 'idNumber');
      if (copyData.length != this.salInsuredList.length) {
        this.$message.warning('受保人有重复，已做删除');
      }
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.salInsuredList);
      this.riskNumber = this.countTimes(this.salInsuredList);
      if (this.salInsuredList.length) {
        this.resultPremiumSum(this.RiskInfos); //计算保费
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    },
    onChangeyueduBtn(e) {
      //理解并阅读
      this.yueduBtn = e.target.checked;
    },
    fastInsure(needUnderwriting) {
      //立即投保
      if (!this.yueduBtn) {
        this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
        return;
      }
      if (needUnderwriting !== '1') {
        this.showPaySure = true;
        return;
      }
      this.$store.commit('setLoading', {
        show: true,
        text: '核保中，请稍后...'
      });
      this.$api
        .payBeforeUnderwriting(this.$route.query.policyId)
        .then(res => {
          if (res.data.returnCode !== '00') {
            this.$notification.error({
              duration: null,
              message: '提示',
              description: res.data.returnMsg
            });
            return;
          }
          this.showPaySure = true;
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
        });
    },

    numResult(data) {
      //统计各个类别被报人人数
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      return d;
    },
    unique(arr, attribute) {
      //提交时 对被保人根据身份证去重
      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
          //  -1代表没有找到
          new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(arr[i]);
        }
      }
      return json_arr;
    },
  },
  mounted() {
    //获取url通用参数参数
    const { u, p, planCode, policyId } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode || p;
    this.policyId = policyId;
    this.userParams = {
      //保存链接数据
      userId: u,
      productCode: this.productCode
    };
    if (this.$route.query.policyId) {
      //policyId存在则查询保单信息
      this.queryOrderDetails(); //查询保单信息
      this.disabledAll = true;
    } else {
      this.disabledAll = false;
    }
  }
};
